import { MainLoader } from '@/_components';

export function MainLoadingLayout() {
  return <MainLoader />;
}
